import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import api from "../../services/api";
import { queryKeys } from "../api/queryKeys";
import { useAppContext } from "../../contexts/AppContext";
import {
  ParcelamentoEspecialParams,
  ParcelamentoEspecialResponse,
} from "../../types/Parcelamento";

export const useParcelamentoEspecial = (
  params: ParcelamentoEspecialParams | null,
  enabled: boolean = true
) => {
  const { getCampanhaSolarValue } = useAppContext();

  return useQuery<ParcelamentoEspecialResponse>({
    queryKey: queryKeys.parcelamentoEspecial(params),
    queryFn: async () => {
      if (!params) {
        throw new Error("Parâmetros não fornecidos");
      }

      const response = await api.get<ParcelamentoEspecialResponse>(
        "parcelamento-especial",
        {
          params: {
            idCampanhaSolar: getCampanhaSolarValue(),
            valorPedido: params.valorPedido,
          },
        }
      );

      if (response.status === 200) {
        if (response.data.condicoesParcelamento) {
          return response.data;
        } else {
          const errorMsg =
            "Ocorreu um erro ao buscar as opções de parcelamento especial.";
          toast.error(errorMsg);
          throw new Error(errorMsg);
        }
      } else {
        if (response.data && response.data.msg_err) {
          const errorMsg = String(response.data.msg_err);
          toast.error(errorMsg);
          throw new Error(errorMsg);
        }
        throw new Error(
          "Não foi possível buscar as condições de parcelamento especial"
        );
      }
    },
    enabled: enabled && params !== null,
    staleTime: 0, // Sempre refetch quando os parâmetros mudarem
    refetchOnMount: "always", // Sempre refetch quando o componente montar
  });
};
